import {
  Component,
  ViewEncapsulation,
  Input,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { takeWhile } from 'rxjs/operators';

import { Product } from '../../../models/product.model';
import { OrderService } from '../../../services/order.service';
import { Order } from '../../../models/order.model';
import {isEmptyArray} from '../../../shared/utils';
import {Address} from '../../../models/address.model';
import {ECOMMERCE_TYPE} from '../../../constants/order-types';
import {AddressService} from '../../../services/address.service';

@Component({
  selector: 'products-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProductsListComponent implements  OnInit, OnDestroy {
  _activeOrder: Order;
  _products: Product[];
  private lastScrollTop = 0;
  private lastScrollLeft = 0;


  private alive = true;


  @ViewChild('tableWrapper', { static: true }) tableWrapper: ElementRef;

  @Input() orderType: string;
  @Output() onEndOfScroll = new EventEmitter<void>();
  @Output() onAddLocation = new EventEmitter<void>();
  @Output() onEditLocation = new EventEmitter<void>();

  @Input() set products(val: Product[]) {
    this._products = val;
  }


  constructor(private orderService: OrderService, private addressService: AddressService) {}

  ngOnInit(): void {

    // catch on scroll end  event
    if (this.tableWrapper) {
      this.tableWrapper.nativeElement.addEventListener('scroll', (event) => {this.handleScroll(event)});
    }


    const orderValue  = this.orderType === ECOMMERCE_TYPE ? 'activeODOrder' : 'activeBWOrder';


    this.orderService.toRx(orderValue).pipe(takeWhile(() => this.alive)).subscribe(data => {
      if (!data || !data.loaded) {
      } else {
        if (!this._activeOrder || !this._activeOrder.isTheSame(data)) {
          this._activeOrder = data;
        } else {
          this._activeOrder = data;
        }
      }
    });
  }

  ngOnDestroy() {
    this.alive = false;
    if (this.tableWrapper) {
      this.tableWrapper.nativeElement.removeEventListener('scroll', (event) => this.handleScroll(event));
    }
  }


  private  handleScroll(event) {
    const element = event.target;
    if (this.lastScrollLeft !== element.scrollLeft) {
      // horizontal scroll
      this.lastScrollLeft = element.scrollLeft;
      return;
    }

    if (element.scrollTop < this.lastScrollTop) {
      // upscroll
      return;
    }
    this.lastScrollTop = element.scrollTop <= 0 ? 0 : element.scrollTop;
    if ((element.scrollTop + element.offsetHeight + 2) >= element.scrollHeight ) {
      this.onEndOfScroll.emit();
    }
  }

  get isEmptyAddressList(): boolean {
    return isEmptyArray(this.addressList);
  }

  addLocation() {
    this.onAddLocation.emit();
  }

  editLocation() {
    this.onEditLocation.emit();
  }


  calcSubtotalsForAddress(address: Address): number {
    if (!address) {
      return 0;
    }

    if (isEmptyArray(this._activeOrder?.items)) {
      return 0;
    }

    let total = 0;

    this._activeOrder.items.forEach( orderItem => {
      if (orderItem.financials_total?.product_total && orderItem.item_cut != true) {
        // find delivery
        const delivery = orderItem.deliveries.find( d => (d.addr_id === address.id &&  d.address_type === address.address_type));
        if (delivery?.quantity) {
          total +=  orderItem.financials_total?.product_total * delivery.quantity / orderItem.quantity;
        }
      }
    });
    return total;
  }

  get addressList(): Address[] {
    if (!this._activeOrder) {
      return [];
    }
    return [...this._activeOrder.findAllOrderAddresses()];
  }

  get canEditOrder(): boolean {
    return this.orderService.canEditOrderItems(this._activeOrder);
  }
}

